/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'tick': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M6.81 8.726L5.116 7.033l-1.6 1.6 3.294 3.293 5.674-5.674-1.6-1.6L6.81 8.725z" _fill="#62E2AA"/><path pid="1" d="M8 0C3.59 0 0 3.59 0 8s3.59 8 8 8 8-3.59 8-8-3.59-8-8-8zm0 14.512A6.519 6.519 0 011.488 8C1.488 4.41 4.41 1.488 8 1.488c3.59 0 6.512 2.921 6.512 6.512 0 3.59-2.921 6.512-6.512 6.512z" _fill="#62E2AA"/>'
  }
})



// WEBPACK FOOTER //
// ./src/assets/icons/tick.js